import React, { createContext, useState, useEffect } from 'react';
import { useOnceEffect } from 'hooks/useOnceEffect';
import {
  iosCreatorUARegex,
  iosListenerUARegex,
  androidCreatorUARegex,
  androidListenerUARegex,
  desktopUARegex
} from 'lib/useragents';

interface ContextProps {
  isEmbed: boolean;
  isiOSCreatorApp: boolean;
  isAndroidCreatorApp: boolean;
  isiOSListenerApp: boolean;
  isAndroidListenerApp: boolean;
  isNativeAppWebview: boolean;
  isDACreatorApp: boolean;
  isListenerAppWebview: boolean;
  isCreatorAppWebview: boolean;
  deviceClassName: string;
}

export const UserAgentContext = createContext<ContextProps>({
  isEmbed: false,
  isiOSCreatorApp: false,
  isAndroidCreatorApp: false,
  isiOSListenerApp: false,
  isAndroidListenerApp: false,
  isNativeAppWebview: false,
  isDACreatorApp: false,
  isListenerAppWebview: false,
  isCreatorAppWebview: false,
  deviceClassName: ''
});

const UserAgentProvider = ({
  children
}: {
  children: React.ReactNode;
}): JSX.Element => {
  const [isEmbed, setEmbed] = useState(false);
  const [isiOSCreatorApp, setiOSCreatorApp] = useState(false);
  const [isAndroidCreatorApp, setAndroidCreatorApp] = useState(false);
  const [isiOSListenerApp, setiOSListenerApp] = useState(false);
  const [isAndroidListenerApp, setAndroidListenerApp] = useState(false);
  const [isDACreatorApp, setDACreatorApp] = useState(false);
  const [isNativeAppWebview, setNativeAppWebview] = useState(false);
  const [isListenerAppWebview, setListenerAppWebview] = useState(false);
  const [isCreatorAppWebview, setCreatorAppWebview] = useState(false);
  const [deviceClassName, setDeviceClassName] = useState('');

  useEffect(() => {
    const ua = navigator.userAgent;
    switch (true) {
      case iosCreatorUARegex.test(ua):
        setiOSCreatorApp(true);
        setDeviceClassName('ios ios-creator');
        break;
      case iosListenerUARegex.test(ua):
        setiOSListenerApp(true);
        setDeviceClassName('ios ios-listener');
        break;
      case androidCreatorUARegex.test(ua):
        setAndroidCreatorApp(true);
        setDeviceClassName('android android-creator');
        break;
      case androidListenerUARegex.test(ua):
        setAndroidListenerApp(true);
        setDeviceClassName('android android-listener');
        break;
      case desktopUARegex.test(ua):
        setDACreatorApp(true);
        setDeviceClassName('creator-da');
        break;
    }
  }, []);

  useEffect(() => {
    setEmbed(window === window.parent ? false : true);
  }, [setEmbed]);

  useOnceEffect(() => {
    setDeviceClassName('embed');
  }, isEmbed);

  useOnceEffect(() => {
    setNativeAppWebview(true);
  }, isiOSCreatorApp || isAndroidCreatorApp || isDACreatorApp || isiOSListenerApp || isAndroidListenerApp);

  useOnceEffect(() => {
    setListenerAppWebview(true);
  }, isiOSListenerApp || isAndroidListenerApp);

  useOnceEffect(() => {
    setCreatorAppWebview(true);
  }, isiOSCreatorApp || isAndroidCreatorApp || isDACreatorApp);

  return (
    <UserAgentContext.Provider
      value={{
        isEmbed,
        isiOSCreatorApp,
        isAndroidCreatorApp,
        isiOSListenerApp,
        isAndroidListenerApp,
        isNativeAppWebview,
        isDACreatorApp,
        isListenerAppWebview,
        isCreatorAppWebview,
        deviceClassName
      }}
    >
      {children}
    </UserAgentContext.Provider>
  );
};

export default UserAgentProvider;
